import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useRef,
} from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  TableContainer,
  Text,
  Spinner,
  Button,
} from "@chakra-ui/react";
import axios from "axios";
import { BASE_URL, IMG_URL } from "../../Globalapi/Globalapi";

const Print_pdf_subject = forwardRef(({ assignments }, ref) => {
  const [staffList, setStaffList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  // const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [schoolDetailes, setSchoolDetailes] = useState({});
  const printRef = useRef();

  useImperativeHandle(ref, () => ({
    handlePrint,
  }));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const school_id = sessionStorage.getItem("school_id");
        console.log("school id in school select:", school_id);
        if (!school_id) {
          alert("No school_id found in session storage.");
          return;
        }

        const response = await axios.get(
          `${BASE_URL}/admin/school/select_school.php`,
          {
            params: {
              school_id: school_id,
            },
          }
        );
        setSchoolDetailes(response.data.data);
        console.log("school result:", response.data.data);
      } catch (error) {
        console.error("error occurred in fetch school result:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const jwt = sessionStorage.getItem("jwt");
        const school_id = sessionStorage.getItem("school_id"); // If JWT is needed
        console.log("school id in stafflist:", school_id);

        // Fetch staff list
        const staffResponse = await axios.get(
          `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );
        setStaffList(staffResponse.data.data || []);

        // Fetch subject list
        const subjectResponse = await axios.get(
          `${BASE_URL}/admin/subject/list_subject.php`,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );
        setSubjectList(subjectResponse.data.data || []);

        // Fetch all assigned subjects
        const assignmentResponse = await axios.get(
          `${BASE_URL}/admin/subject/list_all_teacher_subject_to_admin.php`,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );
        // setAssignments(assignmentResponse.data.data || []);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    // Wait for the image to load before printing
    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve; // Resolve on error to prevent blocking
        })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  return (
    <div
      ref={printRef}
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.5",
      }}
    >
      {/* Header with Logo */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "40px",
          borderBottom: "1px solid #e5e5e5",
          paddingBottom: "20px",
          gap: "24px",
        }}
      >
        <img
          src={schoolDetailes?.image_url ? `${schoolDetailes.image_url}` : ""}
          alt={`${schoolDetailes?.s_name || "School"} Logo`}
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain",
            backgroundColor: "#fff",
            padding: "10px",
          }}
        />

        <div>
          <h1
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontFamily: "'Times New Roman', serif",
              letterSpacing: "0.5px",
            }}
          >
            {schoolDetailes?.s_name || "Loading..."}
          </h1>
          <h2
            style={{
              margin: "6px 0 0",
              fontSize: "18px",
              fontWeight: "500",
              color: "#666",
              fontFamily: "'Times New Roman', serif",
            }}
          >
            {schoolDetailes?.s_address || ""}
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#6C757D",
              margin: "6px 0 0",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {schoolDetailes?.s_email || ""}
          </p>
        </div>
      </div>

      <h3>Teacher-Subject List</h3>

      {/* Table with Teacher and Assignment Data */}
      {loading ? (
        <Spinner size="xl" />
      ) : error ? (
        <Text color="red.500">{error}</Text>
      ) : (
        <TableContainer>
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
            style={{
              border: "1px solid #d4c2c2",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <Thead>
              <Tr>
                <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  Serial No.
                </Th>
                <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  Name
                </Th>
                <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  Subject
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {assignments.map((assignment, index) => (
                <Tr key={index}>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {index + 1}{" "}
                    {/* Serial number (index + 1 for 1-based indexing) */}
                  </Td>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {assignment.staff_name}
                  </Td>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {Array.isArray(assignment.staff_subject)
                      ? assignment.staff_subject.join(", ") // Display subjects as a comma-separated list if it's an array
                      : assignment.staff_subject}{" "}
                    {/* Display as-is if it's a string */}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
});

export default Print_pdf_subject;
